import { Component } from 'react';
import DayProductiveElement from './DayProductiveElement';
import '@app/components/sqdp/all_factory/styles/productive-layout.css';
import dayjs from 'dayjs';

class ProductiveLayout extends Component {
  state = {
    showInfo: false,
    element: {},
  };

  showInfo = (num) => {
    this.props.showIssueInfo(num, 4);
  };

  getColorOfDayInt = (issueOfDay, dateNum) => {
    if (!issueOfDay) return 'emtpy_state';

    const {
      isRestDay,
      highestProductivityProductionDownTimeMinutes = 0,
      countProductivityTotal = 0,
      countProductivityIsStopProduce = 0,
    } = issueOfDay;

    const thisDay = dayjs().date(dateNum).day();
    const today = dayjs();
    const selectedTime = dayjs(this.props.selectedMonth);

    // ⛱ Ngày nghỉ cuối tuần
    if (isRestDay && (thisDay === 6 || thisDay === 0)) {
      return 'emtpy_state';
    }
    if (
      today.get('month') <= selectedTime.get('month') &&
      today.get('year') <= selectedTime.get('year') &&
      dateNum > today.get('date')
    ) {
      return 'emtpy_state';
    }

    // 🔴 Có thời gian dừng sản xuất > 30
    if (highestProductivityProductionDownTimeMinutes > 30) {
      return 'red_state';
    }

    // 🟢 Không dừng sản xuất (= 0)
    if (highestProductivityProductionDownTimeMinutes === 0) {
      return 'green_state';
    }

    // 🟡 Có thời gian dừng sản xuất
    return 'yellow_state';
  };

  getColorOfDayCbm = (issueOfDay, dateNum) => {
    if (!issueOfDay) return 'emtpy_state';

    const {
      isRestDay,
      highestProductivityProductionDownTimeMinutes = 0,
      countProductivityTotal = 0,
      countProductivityIsStopProduce = 0,
    } = issueOfDay;

    const thisDay = dayjs().date(dateNum).day();
    const today = dayjs();
    const selectedTime = dayjs(this.props.selectedMonth);

    // ⛱ Ngày nghỉ cuối tuần
    if (isRestDay && (thisDay === 6 || thisDay === 0)) {
      return 'emtpy_state';
    }
    if (
      today.get('month') <= selectedTime.get('month') &&
      today.get('year') <= selectedTime.get('year') &&
      dateNum > today.get('date')
    ) {
      return 'emtpy_state';
    }

    // 🔴 Có thời gian dừng sản xuất > 30
    if (highestProductivityProductionDownTimeMinutes > 30) {
      return 'red_state';
    }

    // 🟢 Không dừng sản xuất (= 0)
    if (highestProductivityProductionDownTimeMinutes === 0) {
      return 'green_state';
    }

    // 🟡 Có thời gian dừng sản xuất
    return 'yellow_state';
  };

  getColorOfDaySpa = (issueOfDay, dateNum) => {
    if (issueOfDay) {
      let thisDay = dayjs().date(dateNum).day();
      if (issueOfDay.isRestDay && (thisDay == 6 || thisDay == 0)) {
        return 'emtpy_state';
      }
      if (!issueOfDay.countProductivityTotal || issueOfDay.countProductivityTotal <= 0) {
        let today = dayjs();
        let selectedTime = dayjs(this.props.selectedMonth);
        if (
          today.get('month') <= selectedTime.get('month') &&
          today.get('year') <= selectedTime.get('year') &&
          dateNum == today.get('date')
        ) {
          return 'emtpy_state';
        }

        return 'green_state';
      }

      if (!issueOfDay.countProductivityIsStopProduce || issueOfDay.countProductivityIsStopProduce <= 0) {
        return 'yellow_state';
      }

      if (issueOfDay.countProductivityIsStopProduce > 0) {
        return 'red_state';
      }
    }

    return 'emtpy_state';
  };

  getColorOfDay = (
    issueOfDayFac,
    issueOfDayIqc,
    issueOfDayInt,
    issueOfDayCbm,
    issueOfDayWh,
    issueOfDaySpa,
    dateNum,
  ) => {
    let thisDay = dayjs().date(dateNum).day();
    if (issueOfDayFac) {
      let today = dayjs();
      let selectedTime = dayjs(this.props.selectedMonth);
      if (
        today.get('month') <= selectedTime.get('month') &&
        today.get('year') <= selectedTime.get('year') &&
        dateNum > today.get('date')
      ) {
        return 'emtpy_state';
      }

      const colorInt = this.getColorOfDayInt(issueOfDayInt, dateNum);
      const colorCbm = this.getColorOfDayCbm(issueOfDayCbm, dateNum);
      const colorSpa = this.getColorOfDaySpa(issueOfDaySpa, dateNum);

      if (
        colorInt === 'emtpy_state' &&
        colorCbm === 'emtpy_state' &&
        colorSpa === 'emtpy_state' &&
        (thisDay == 6 || thisDay == 0)
      ) {
        return 'emtpy_state';
      }

      if (
        ![colorInt, colorCbm, colorSpa].includes('yellow_state') &&
        ![colorInt, colorCbm, colorSpa].includes('red_state')
      ) {
        return 'green_state';
      }

      if ([colorInt, colorCbm, colorSpa].includes('red_state')) {
        return 'red_state';
      }

      return 'yellow_state';
    }

    return 'emtpy_state';
  };
  populateElements = (start, end) => {
    let items = [];
    for (let i = start; i <= end; i++) {
      let issueOfDayFac = this.props?.dataInMonthFac[i - 1];
      let issueOfDayIqc = this.props?.dataInMonthIqc[i - 1];
      let issueOfDayInt = this.props?.dataInMonthInt[i - 1];
      let issueOfDayCbm = this.props?.dataInMonthCbm[i - 1];
      let issueOfDayWh = this.props?.dataInMonthWh[i - 1];
      let issueOfDaySpa = this.props?.dataInMonthSpa[i - 1];

      let color = this.getColorOfDay(
        issueOfDayFac,
        issueOfDayIqc,
        issueOfDayInt,
        issueOfDayCbm,
        issueOfDayWh,
        issueOfDaySpa,
        i,
      );
      items.push(
        <DayProductiveElement
          showInfo={this.showInfo}
          oneTypeIssue={this.props.oneTypeIssue}
          num={i}
          color={color}
          issues={issueOfDayInt}
          lastClickedElement={this.props.lastClickedElement}
          lastGroupClicked={this.props.lastGroupClicked}
        />,
      );
    }
    return items;
  };

  render() {
    return (
      // <div className="wrapper">
      <>
        <div id="table-productive">
          {/* Elements 1-4 */}
          {this.populateElements(1, 32)}
          {/* Information Table */}
          {/* {this.state.showInfo && (
            <Fragment>
              <div id="element-box" className={`${category}`}>
                <div className="number">{number}</div>
                <div className="symbol">{symbol}</div>
                <div className="element-name">{name}</div>
              </div>
              <div id="information">
                <div
                  onClick={this.closeInfo}
                  className="close-button"
                  title="Close Info"
                >
                  Close [&times;]
                </div>
                <div>
                  <h1 className="big_title">{name}</h1>
                  <span className={`cat_name ${category}`}>{category}</span>
                  {appearance && (
                    <div className="appearance">
                      <strong>Appearance:</strong> {appearance}
                    </div>
                  )}
                  <div className="atom_info">
                    <span>Atomic Mass: {atomic_mass} | </span>
                    <span>Density: {density}</span>
                    {molar_heat && <span> | Molar Heat: {molar_heat}</span>}
                    {melt && <span> | Melt: {melt}K</span>}
                    {boil && <span> | Boil: {boil}K</span>}
                  </div>
                  <div>
                    {summary} ...{" "}
                    <a target="_blank" href={source}>
                      Source
                    </a>
                  </div>
                </div>
              </div>
            </Fragment>
          )} */}

          {/* {this.populateElements(5, 57)}
          {this.populateElements(72, 89)}
          {this.populateElements(104, 118)}
          {this.populateElements(58, 71)}
          {this.populateElements(90, 103)} */}
        </div>
        {this.props.factory ? (
          <></>
        ) : (
          <h3 className="center" style={{ paddingLeft: '50px', marginTop: '20px' }}>
            Productivity
          </h3>
        )}
      </>
    );
  }
}

export default ProductiveLayout;
